module.exports = __webpack_public_path__ + "media/public/images/slider/banner_mobile-a05430baa3c158b7b498814d41c411ff.png";